const pt = {
  nav: {
    home: "In\u00edcio",
    browse: "Explorar Casamentos",
    browseWeddings: "Explorar Casamentos",
    dashboard: "Painel",
    messages: "Mensagens",
    profile: "Perfil",
    login: "Entrar",
    register: "Registrar",
    logout: "Sair",
    admin: "Admin",
  },
  landing: {
    hero: {
      badge: "A plataforma #1 de experi\u00eancias de casamento",
      title: "Viva Casamentos Inesquec\u00edveis pelo Mundo",
      subtitle: "WEDVAYA conecta casais com viajantes que buscam experi\u00eancias culturais aut\u00eanticas. Fa\u00e7a parte de um momento especial \u2013 como anfitri\u00e3o ou convidado.",
      cta_host: "Come\u00e7ar como Anfitri\u00e3o",
      cta_guest: "Descobrir Casamentos",
    },
    trust: {
      freeRegistration: "Registro gratuito",
      securePayment: "Pagamento seguro",
      gdprCompliant: "Conforme GDPR",
    },
    stats: {
      weddings: "Casamentos",
      worldwide: "pelo mundo",
      guests: "Convidados",
      matched: "conectados",
      countries: "Pa\u00edses",
      represented: "representados",
      rating: "Avalia\u00e7\u00e3o",
      average: "m\u00e9dia",
    },
    features: {
      title: "Por que WEDVAYA?",
      subtitle: "Tornamos o compartilhamento de experi\u00eancias de casamento inesquec\u00edveis f\u00e1cil e seguro.",
      secure: {
        title: "Pagamentos Seguros",
        desc: "Todas as transa\u00e7\u00f5es s\u00e3o protegidas pelo Stripe. Seu dinheiro est\u00e1 seguro at\u00e9 o evento.",
      },
      verified: {
        title: "Perfis Verificados",
        desc: "Verifica\u00e7\u00e3o de identidade opcional para maior confian\u00e7a entre anfitri\u00f5es e convidados.",
      },
      global: {
        title: "Eventos Globais",
        desc: "De casamentos rom\u00e2nticos na Toscana a celebra\u00e7\u00f5es tradicionais na \u00cdndia.",
      },
      contact: {
        title: "Contato Direto",
        desc: "Ap\u00f3s a reserva, voc\u00ea pode se comunicar diretamente com o anfitri\u00e3o.",
      },
      gdpr: {
        title: "Conforme GDPR",
        desc: "Seus dados est\u00e3o seguros. Cumprimos rigorosamente as diretrizes europeias de prote\u00e7\u00e3o de dados.",
      },
      instant: {
        title: "Reserva Instant\u00e2nea",
        desc: "Processo de inscri\u00e7\u00e3o r\u00e1pido. Voc\u00ea receber\u00e1 uma resposta em 48 horas.",
      },
    },
    howItWorks: {
      title: "Como Funciona",
      subtitle: "Apenas alguns passos para sua experi\u00eancia inesquec\u00edvel",
      step1: {
        title: "Encontre um Casamento",
        desc: "Navegue pela nossa sele\u00e7\u00e3o de casamentos \u00fanicos pelo mundo.",
      },
      step2: {
        title: "Envie sua Candidatura",
        desc: "Apresente-se ao casal e conte por que deseja participar.",
      },
      step3: {
        title: "Confirma\u00e7\u00e3o e Pagamento",
        desc: "Ap\u00f3s aprova\u00e7\u00e3o, pague com seguran\u00e7a online. S\u00f3 ent\u00e3o sua vaga est\u00e1 reservada.",
      },
      step4: {
        title: "Celebre",
        desc: "Viva um casamento aut\u00eantico e crie mem\u00f3rias para a vida toda.",
      },
    },
    howItWorksHost: {
      step1: {
        title: "Publique seu Casamento",
        desc: "Crie um perfil para seu casamento com todos os detalhes importantes.",
      },
      step2: {
        title: "Analise as Candidaturas",
        desc: "Confira os perfis dos convidados interessados.",
      },
      step3: {
        title: "Receba o Pagamento",
        desc: "Ap\u00f3s o evento, voc\u00ea recebe automaticamente 85% da receita.",
      },
      step4: {
        title: "Celebre Juntos",
        desc: "Compartilhe seu dia especial com pessoas de todo o mundo.",
      },
    },
    tabs: {
      forGuests: "Para Convidados",
      forHosts: "Para Anfitri\u00f5es",
    },
    testimonials: {
      title: "O que nossa comunidade diz",
      subtitle: "Experi\u00eancias reais de pessoas reais",
    },
    featured: {
      title: "Casamentos em Destaque",
      subtitle: "Descubra celebra\u00e7\u00f5es \u00fanicas pelo mundo",
      viewAll: "Ver Todos",
      perPerson: "por pessoa",
    },
    cta: {
      title: "Pronto para sua Experi\u00eancia Inesquec\u00edvel?",
      subtitle: "Junte-se \u00e0 comunidade WEDVAYA",
      description: "Se voc\u00ea quer compartilhar seu casamento com o mundo ou busca uma experi\u00eancia de viagem \u00fanica \u2013 WEDVAYA torna isso poss\u00edvel.",
      button: "Registrar-se Gr\u00e1tis",
      becomeHost: "Tornar-se Anfitri\u00e3o",
      learnMore: "Saiba Mais",
    },
    press: {
      title: "Visto em",
    },
  },
  auth: {
    login: {
      title: "Bem-vindo de Volta",
      email: "Email",
      password: "Senha",
      button: "Entrar",
      noAccount: "N\u00e3o tem conta?",
      register: "Registre-se agora",
      forgotPassword: "Esqueceu a senha?",
    },
    register: {
      title: "Criar Conta",
      name: "Nome Completo",
      email: "Email",
      password: "Senha",
      role: "Eu quero...",
      roleHost: "Organizar um casamento",
      roleGuest: "Participar de casamentos",
      terms: "Aceito os Termos e Pol\u00edtica de Privacidade",
      button: "Registrar",
      hasAccount: "J\u00e1 tem conta?",
      login: "Entre agora",
    },
    forgotPassword: {
      title: "Esqueceu a Senha?",
      description: "Digite seu email e enviaremos um link de redefini\u00e7\u00e3o",
      submit: "Enviar Link",
      sent: "Verifique seu Email",
      sentDescription: "Se existir uma conta com este email, voc\u00ea receber\u00e1 um link para redefinir sua senha.",
      backToLogin: "Voltar ao Login",
    },
    resetPassword: {
      title: "Redefinir Senha",
      description: "Digite sua nova senha",
      newPassword: "Nova Senha",
      confirmPassword: "Confirmar Senha",
      submit: "Redefinir Senha",
      success: "Senha Redefinida!",
      successDesc: "Sua senha foi redefinida com sucesso. Agora voc\u00ea pode fazer login.",
      goToLogin: "Ir para Login",
      mismatch: "As senhas n\u00e3o coincidem",
      tooShort: "A senha deve ter no m\u00ednimo 6 caracteres",
    },
    verification: {
      verifying: "Verificando seu email...",
      pleaseWait: "Por favor, aguarde",
      successTitle: "Email Verificado!",
      success: "Seu email foi verificado com sucesso!",
      errorTitle: "Verifica\u00e7\u00e3o Falhou",
      noToken: "Nenhum token de verifica\u00e7\u00e3o fornecido",
      goToLogin: "Ir para Login",
      tryAgain: "Registrar Novamente",
    },
  },
  dashboard: {
    host: {
      title: "Painel do Anfitri\u00e3o",
      myWeddings: "Meus Casamentos",
      applications: "Candidaturas",
      earnings: "Ganhos",
      messages: "Mensagens",
      createWedding: "Criar Casamento",
      noWeddings: "Nenhum casamento criado ainda",
    },
    guest: {
      title: "Painel do Convidado",
      myApplications: "Minhas Candidaturas",
      browseWeddings: "Explorar Casamentos",
      messages: "Mensagens",
      profile: "Meu Perfil",
    },
  },
  wedding: {
    search: {
      title: "Encontrar Casamentos",
      location: "Localiza\u00e7\u00e3o",
      date: "Data",
      price: "Pre\u00e7o",
      search: "Buscar",
      reset: "Limpar",
      noResults: "Nenhum casamento encontrado",
    },
    card: {
      slots: "vagas dispon\u00edveis",
      perGuest: "por convidado",
      apply: "Candidatar-se",
      viewDetails: "Ver Detalhes",
    },
    detail: {
      about: "Sobre este Casamento",
      host: "Anfitri\u00e3o",
      location: "Localiza\u00e7\u00e3o",
      date: "Data",
      dresscode: "C\u00f3digo de Vestimenta",
      price: "Pre\u00e7o por Convidado",
      slots: "Vagas Dispon\u00edveis",
      apply: "Candidatar-se Agora",
      alreadyApplied: "J\u00e1 se Candidatou",
    },
    create: {
      title: "Criar Novo Casamento",
      titleField: "T\u00edtulo",
      description: "Descri\u00e7\u00e3o",
      location: "Localiza\u00e7\u00e3o",
      country: "Pa\u00eds",
      date: "Data",
      dresscode: "C\u00f3digo de Vestimenta",
      price: "Pre\u00e7o por Convidado",
      slots: "N\u00famero de Convidados",
      currency: "Moeda",
      submit: "Criar Casamento",
    },
  },
  application: {
    status: {
      pending: "Pendente",
      approved: "Aprovado",
      rejected: "Rejeitado",
    },
    payment: {
      pending: "Pagamento Pendente",
      paid: "Pago",
      pay: "Pagar Agora",
    },
    approve: "Aprovar",
    reject: "Rejeitar",
  },
  review: {
    title: "Write a Review",
    description: "Share your experience with",
    ratingLabel: "How would you rate your experience?",
    rating1: "Poor",
    rating2: "Fair",
    rating3: "Good",
    rating4: "Very Good",
    rating5: "Excellent",
    commentLabel: "Your Review",
    optional: "optional",
    commentPlaceholder: "Tell others about your experience...",
    for: "Review for",
    submit: "Submit Review",
    success: "Review submitted successfully!",
    error: "Failed to submit review",
    selectRating: "Please select a rating",
    noReviews: "No reviews yet",
    received: "Reviews Received",
    averageRating: "Average Rating",
    writeReview: "Write Review",
    reviewed: "Reviewed",
    completedWedding: "This wedding has been completed. You can now write a review.",
  },

  messages: {
    title: "Mensagens",
    noMessages: "Sem mensagens",
    placeholder: "Escreva uma mensagem...",
    send: "Enviar",
  },
  admin: {
    title: "Painel Admin",
    stats: {
      users: "Usu\u00e1rios",
      hosts: "Anfitri\u00f5es",
      guests: "Convidados",
      weddings: "Casamentos",
      activeWeddings: "Casamentos Ativos",
      applications: "Candidaturas",
      revenue: "Receita Total",
      platformEarnings: "Ganhos da Plataforma",
    },
    tabs: {
      overview: "Vis\u00e3o Geral",
      users: "Usu\u00e1rios",
      weddings: "Casamentos",
      transactions: "Transa\u00e7\u00f5es",
    },
    actions: {
      ban: "Banir",
      unban: "Desbanir",
      feature: "Destacar",
      unfeature: "Remover Destaque",
    },
  },
  common: {
    loading: "Carregando...",
    error: "Ocorreu um erro",
    success: "Sucesso",
    save: "Salvar",
    cancel: "Cancelar",
    delete: "Excluir",
    edit: "Editar",
    back: "Voltar",
    next: "Pr\u00f3ximo",
    language: "Idioma",
    currency: "Moeda",
  },
  footer: {
    about: "Sobre",
    privacy: "Privacidade",
    terms: "Termos",
    contact: "Contato",
    description: "A plataforma global para experi\u00eancias de casamento inesquec\u00edveis.",
    copyright: "\u00a9 2024 WEDVAYA. Todos os direitos reservados.",
  },
  notifications: {
    title: "Notifica\u00e7\u00f5es",
    empty: "Nenhuma notifica\u00e7\u00e3o ainda",
    markAllRead: "Marcar tudo como lido",
  },
  chat: {
    conversations: "Conversas",
    search: "Buscar conversas...",
    noConversations: "Nenhuma conversa ainda",
    selectConversation: "Selecione uma conversa",
    selectConversationDesc: "Escolha uma conversa da lista para come\u00e7ar a conversar",
    online: "Online",
    offline: "Offline",
    connecting: "Conectando...",
    noMessages: "Nenhuma mensagem ainda",
    startConversation: "Inicie a conversa!",
    placeholder: "Digite uma mensagem...",
    you: "Voc\u00ea",
  },
  cookies: {
    title: "Usamos cookies",
    description: "Usamos cookies para melhorar sua experi\u00eancia, analisar o tr\u00e1fego e para fins de marketing.",
    acceptAll: "Aceitar Tudo",
    rejectAll: "Rejeitar Tudo",
    customize: "Personalizar",
    settingsTitle: "Configura\u00e7\u00f5es de Cookies",
    functional: "Cookies Funcionais",
    functionalDesc: "Essenciais para o funcionamento do site.",
    analytics: "Cookies de An\u00e1lise",
    analyticsDesc: "Nos ajudam a entender como os visitantes interagem com o site.",
    marketing: "Cookies de Marketing",
    marketingDesc: "Usados para exibir an\u00fancios personalizados.",
    saveSettings: "Salvar Configura\u00e7\u00f5es",
  },
};

export default pt;
